import React, { useEffect, useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Form, Button } from 'react-bootstrap';
import { Select } from 'antd';
import authHeader from "../../services/auth-header";
import _db, { getTruckingCompanies, getUserTerminal, getBookedEquipment, getLinesWithPositiveRemainder, isRF } from "../../services/kiosque-service";
import AuthService from "../../services/auth.service";

import 'antd/dist/antd.css';

const ERROR_CLASS = '.is-invalid';
const user = AuthService.getCurrentUser();

const StepOne = ({ formData, updateFormData, navigate, logAction }) => {
    const { t, i18n } = useTranslation();
    const { Option } = Select;

    const isMounted = useRef(true);
    const { truckingCompany, truckNumber, licencePlate } = formData;
    const [truckingCompanies, setTruckingCompanies] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [errors, setErrors] = useState({});

    //Load on startup
    useEffect(() => {
        isMounted.current = true;
        return () => {
            isMounted.current = false; // Se d�clenche quand on quitte l'�tape
        };
    }, []);

    useEffect(() => {
        let isMounted = true;

        async function getTruckingCompaniesData() { 
            try {
                const companiesList = await getTruckingCompanies();

                if (isMounted) {
                    setTruckingCompanies(companiesList);
                }

            } catch (error) {
                console.error("Erreur inattendue dans le composant !", error);
                if (isMounted) {
                    setTruckingCompanies([]); 
                }
            }
        }

        getTruckingCompaniesData(); 

        return () => {
            isMounted = false; // Nettoyage
        };
    }, []); 
    
    useEffect(() => {
        let isMounted = true; 

        if (isMounted && truckingCompany && truckingCompanies.length > 0) { 
            const transport = truckingCompanies.find((w) => w.id === truckingCompany);
            updateFormData({ transport });
        }

        return () => {
            isMounted = false; 
        };
    }, [truckingCompany]);

    useEffect(() => {
        let isMounted = true;

        async function getUserTerminalData(userCode) {
            try {
                const terminal = await getUserTerminal(userCode);

                if (isMounted) {
                    updateFormData({ user: user.userName, terminal });
                }

            } catch (error) {
                // Ce catch n'est techniquement plus n�cessaire
                console.error("Erreur inattendue dans le composant:", error);
            }
        }

        if (user.userName) {
            getUserTerminalData(user.userName);
        }

        return () => {
            isMounted = false;
        };
    }, [user?.userName]); 

    const getBookData = async (bookNumber) => {
        try {
            let url = "/api/kiosqueGetBookData";
            const response = await _db.get(url, { headers: authHeader(), params: { bookNumber } });

            const bookDetails = response.data;

            return { success: true, book: bookDetails }; 
        } catch (error) {
            console.error("Erreur lors de la r�cup�ration du booking :", error);

            // On extrait le message d'erreur de l'API 
            const errorMessage = error.response?.data || "Erreur inconnue";

            return { success: false, book: {}, errorMessage: errorMessage };
        }
    };

    function focusFirstErrorField() {
        const firstFieldWithError = document.querySelector(ERROR_CLASS);

        if (firstFieldWithError) {
            firstFieldWithError.focus();
        }       
    }

    //const handleChange = (e) => {
    //    updateFormData({ [e.target.name]: e.target.value.trim().toUpperCase() });
    //    //const { name, value } = e.target;
    //    //updateFormData({ [name]: value.toUpperCase() });
    //};

    //const handleTruckingCompanyChange = (value) => {
    //    updateFormData({ truckingCompany: value });
    //};

    const handleTruckingCompanyChange = (value) => {
        // 1. Si value est undefined (allowClear), on passe une cha�ne vide ou null
        handleChange('truckingCompany', value || '');
    };

    const handleChange = (field, value) => {
        updateFormData({ [field]: value.toUpperCase() });

        if (errors[field]) {
            setErrors(prevErrors => {
                const newErrors = { ...prevErrors };
                delete newErrors[field]; // Ou newErrors[field] = null;
                return newErrors;
            });
        }
    }

    const handleNext = async (e) => {
        e.preventDefault();

        // Protection contre les clics multiples (Double-click)
        if (isLoading) return;


        // LOG DE D�MARRAGE UNIQUE (D�s le premier clic sur le bouton)
        if (!formData.isStarted) {
            logAction(1, 'TRANSACTION_STARTED');

            // On verrouille pour ne plus jamais repasser ici durant cette session
            updateFormData({ isStarted: true });
        }

        // 1. S�curit� : V�rification utilisateur/terminal
        if (!formData.user || !formData.terminal) {
            const error = "UNKNOWN_USER_OR_TERMINAL_MSG";
            logAction(1, 'FATAL_ERROR', { reason: error });
            updateFormData({ errorMessage: error });
            navigate(8);
            return;
        }

        // 2. Validation Locale (Champs vides)
        const cleanBookNum = formData.bookNumber?.trim().toUpperCase();
        const { isValid, errors: localErrors } = validateFields({
            truckingCompany: formData.truckingCompany,
            truckNumber: formData.truckNumber,
            licencePlate: formData.licencePlate,
            bookNumber: formData.bookNumber
        });
        //const { isValid, errors: localErrors } = validateFields({ truckingCompany, truckNumber, licencePlate, bookNumber: cleanBookNum });

        if (!isValid) {
            setErrors(localErrors);
            //logAction(1, 'VALIDATION_FAIL', {
            //    errors: localErrors,
            //    attemptedValues: {
            //        truckingCompany: formData.truckingCompany,
            //        truckNumber: formData.truckNumber,
            //        licencePlate: formData.licencePlate
            //    }
            //});
            requestAnimationFrame(focusFirstErrorField);
            return;
        }

        // D�but de la phase asynchrone
        setIsLoading(true);
        //const startTime = Date.now();

        try {
            const res = await getBookData(cleanBookNum);
            //const duration = Date.now() - startTime;

            if (!isMounted.current) return;

            if (res.success) {
                //logAction(1, 'BOOKING_FOUND', {
                //    bookNum: cleanBookNum,
                //    truckingCompany: formData.transport?.transport1?.trim() || formData.truckingCompany, 
                //    truckNumber: formData.truckNumber,
                //    licencePlate: formData.licencePlate,
                //    terminal: formData.terminal?.rstaTerminal,
                //    language: i18n.language,
                //    //responseTimeMs: duration
                //});

            } else {
                setErrors({ ...localErrors, bookNumber: 'incorrectNumberOrInvalidBooking' });
                //logAction(1, 'BOOKING_NOT_FOUND', { bookNum: cleanBookNum });
                requestAnimationFrame(focusFirstErrorField);
                setIsLoading(false);
                return;
            }

            const bookDetails = res.book;

            // 4. R�cup�ration des �quipements book�s
            const bookedItems = await getBookedEquipment(cleanBookNum);
            if (!bookedItems || bookedItems.length === 0) {
                throw new Error("NO_EQUIPMENT_MSG");
            }

            // 5. Analyse des lignes disponibles (Remainder > 0)
            const availableLines = getLinesWithPositiveRemainder(bookedItems);

            if (availableLines.length === 0) {
                throw new Error("NO_EQUIPMENT_MSG");
            }

            // 6. D�tection des sp�cificit�s (Genset / Bundle)
            const hasGenset = availableLines.some(item => item.size === "GENSET");
            const gensetLine = availableLines.find(item => item.size === "GENSET");
            const otherLines = availableLines.filter(item => item.size !== "GENSET");

            const isBundleBooking = bookDetails?.bundle;

            // --- D�CISION DU SC�NARIO ---

            // SC�NARIO 3 : BUNDLE (�tape 2)
            if (isBundleBooking) {
                //logAction(1, 'SCENARIO_BUNDLE', { bookNum: cleanBookNum });
                updateFormData({
                    bookData: bookDetails,
                    bookedEquipment: bookedItems,
                    isBundle: true,
                    line: bookedItems[0]
                });
                navigate(2);
                return;
            }

            // SC�NARIO 1 : BOOKING pour 1 CNTR OU 1 CNTR + GENSET (Auto-s�lection -> �tape 4)
            const hasOneLineOrOneWithGenset = availableLines.length === 1 || (availableLines.length === 2 && hasGenset);

            if (hasOneLineOrOneWithGenset) {
                // Si otherLines existe (cas 2 lignes avec Genset), on prend la premi�re.
                // Sinon, on prend la seule ligne de availableLines.
                const targetLine = otherLines?.[0] || availableLines?.[0];
                if (!targetLine) {
                    throw new Error("NO_VALID_EQUIPMENT_FOUND");
                }

                //Logique du Genset: On ne l'attache que si c'est un RF ET qu'un Genset est dispo
                const needsGenset = isRF(targetLine) && hasGenset;

                //logAction(1, 'SCENARIO_AUTO_SELECT', {
                //    iso: targetLine.isoCode,
                //    attachGenset: needsGenset,
                //    reason: availableLines.length === 2 ? "ONE_LINE_PLUS_GENSET" : "SINGLE_LINE"
                //});

                updateFormData({
                    bookData: bookDetails,
                    bookedEquipment: bookedItems,
                    isBundle: false,
                    line: targetLine,
                    attachGenset: needsGenset,
                    genset: needsGenset ? gensetLine : {}
                });

                navigate(4); 
                return;
            }

            // SC�NARIO 2 : PLUSIEURS �QUIPEMENTS (S�lection manuelle -> �tape 3)
            //logAction(1, 'SCENARIO_MANUAL_SELECT', { options_count: otherLines.length });
            updateFormData({
                bookData: bookDetails,
                bookedEquipment: bookedItems,
                isBundle: false
            });

            navigate(3);

        } catch (err) {
            const errorKey = err.message || "apiError";
            //logAction(1, 'PROCESS_ERROR', { error: errorKey });
            updateFormData({ errorMessage: errorKey });

            navigate(8);

        } finally {
            if (isMounted.current) {
                setIsLoading(false);
            }
        }
    };

    const handleBookingKeyPress = (e) => {
        if (e.key === 'Enter') {
            e.preventDefault(); 
            handleNext(e);  
        }
    };

    /* ************* VALIDATION ******************** */
    const validateFields = (data) => {
        const errors = {};

        if (!data.truckingCompany?.trim()) {
            errors.truckingCompany = 'selectTruckingCompanyError';
        }

        if (!data.truckNumber?.trim()) {
            errors.truckNumber = 'enterTruckNumberError';
        }

        if (!data.licencePlate?.trim()) {
            errors.licencePlate = 'enterLicencePlateError';
        }

        if (!data.bookNumber?.trim()) {
            errors.bookNumber = 'enterBookNumberError';
        }

        return {
            isValid: Object.keys(errors).length === 0,
            errors
        };
    };
    /* ************* END VALIDATION **************** */

    //console.log("setp 1...", formData);

    return (
        <Form className="kform">
            <div className="text-end fw-bold fs-4 mb-3">Pre-Interchange</div>

            <Form.Group className="mb-3">
                <Form.Label className="klabel fw-bold">{t('truckingCompany')}</Form.Label>
                <Select
                    name="truckingCompany"
                    showSearch
                    optionFilterProp="children"
                    size="large"
                    allowClear={true}
                    value={formData.truckingCompany || undefined}
                    // Utilisation de la prop 'status' d'Ant Design pour la bordure rouge
                    status={errors.truckingCompany ? 'error' : ''}
                    className="w-100"
                    onChange={handleTruckingCompanyChange}
                > 
                    {truckingCompanies.map(item => (
                        <Option key={item.id} value={item.id}>{item.transport1}</Option>
                    ))}
                </Select>
                {errors.truckingCompany && (
                    <div className="d-block invalid-feedback fw-bold">{t(errors.truckingCompany)}</div>
                )}
            </Form.Group>

            <Form.Group controlId="truckNumber" className="mb-3">
                <Form.Label className="fw-bold">{t('truckNumber')}</Form.Label>
                <Form.Control
                    name="truckNumber"
                    type="text"
                    value={formData.truckNumber || ''}
                    onChange={(e) => handleChange('truckNumber', e.target.value)}
                    isInvalid={!!errors.truckNumber}
                    className="text-uppercase"
                    size="lg"
                    //autoComplete="off" // �vite les suggestions 
                />
                {errors.truckNumber && (
                    <Form.Control.Feedback type="invalid" className="fw-bold">{t(errors.truckNumber)}</Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group controlId="licencePlate" className="mb-3">
                <Form.Label className="fw-bold">{t('licencePlate')}</Form.Label>
                <Form.Control
                    name="licencePlate"
                    type="text"
                    value={formData.licencePlate || ''}
                    onChange={(e) => handleChange('licencePlate', e.target.value)}
                    isInvalid={!!errors.licencePlate}
                    className="text-uppercase"
                    size="lg"
                    //autoComplete="off"
                />
                {errors.licencePlate && (
                    <Form.Control.Feedback type="invalid" className="fw-bold">{t(errors.licencePlate)}</Form.Control.Feedback>
                )}
            </Form.Group>

            <Form.Group controlId='bookNumber' className="mb-4">
                <Form.Label className="klabel fw-bold">{t('bookingNumber')}</Form.Label>
                <Form.Control
                    name="bookNumber"
                    type='text'
                    className="text-uppercase text-center fw-bold"
                    value={formData.bookNumber || ''}
                    onChange={(e) => handleChange('bookNumber', e.target.value)}
                    onKeyPress={handleBookingKeyPress}
                    isInvalid={!!errors.bookNumber}
                    size="lg"
                    //autoComplete="off"
                />
                {errors.bookNumber && (
                    <Form.Control.Feedback type='invalid' className="fw-bold">{t(errors.bookNumber)}</Form.Control.Feedback>
                )}
            </Form.Group>

            {/* Boutons de navigation */}
            <Form.Group className="d-flex justify-content-between mt-4">
                <Button type="button" variant="secondary" className="fw-bold px-4" disabled>LIFT IN</Button>
                <Button type="button" variant="primary" className="fw-bold px-4" onClick={handleNext}>LIFT OUT</Button>
            </Form.Group>
        </Form>
    );
};

export default StepOne;